 <template>
  <div class="bg">
  	  <img src="@assets/images/cards.png" />
  	  <div class="forms">
  	  	<input 
  	  		type="text" 
  	  		placeholder="请输入卡号"
            v-model="cardsn"
  	  		>
  	    <input 
  	  		type="text" 
  	  		placeholder="请输入密码"
            v-model="pwd"
  	  		>
  	   <img src="@assets/images/sub.png"  @click="convert" />
  	  </div>
  </div>
</template>
<script>
import { getUser , getConvert } from "@api/user";



export default {  
   data: function() {
    return {
     
      	cardsn:'',
        pwd:'',
        uid:'',
        msg:'',
        showHid:''
        
    };
  },
  mounted: function() {
    this.User();
    this.Pad();
  },
  methods: {
  	convert(){
      let that = this;
  		let headers = {
		'content-type': 'application/x-www-form-urlencoded'
	    }

      let lg = that.cardsn.length
	    let url = 'http://www.fangyangwang.cn/ecash_backend/chequecard'
  		let param = new FormData()
  		param.append('cardsn', that.cardsn)
  		param.append('pwd', that.pwd)
  		param.append('uid', that.uid)
  		

      // console.log(that.cardsn)
      if(that.cardsn){
         // if(lg>10){
           that.$axios({
          header:headers,
                method:'post',
                url:url,
                data:param
            }).then((response) =>{          //这里使用了ES6的语法
                console.log(response)       //请求成功返回的数据
                if(response.status==200){
                  that.msg = '兑换成功，请查收余额';
                  that.$dialog.toast({ mes: that.msg });
                  // setTimeout(
                  //   function(){
                  //     this.$router.push({ path: '/user'})
                  //   }
                  //   , 1000);
                }
            }).catch((error) =>{
                console.log(error.response)       //请求失败返回的数据
                if(error.response.data.code == 422){
                  that.msg = error.response.data.msg;
                }else{
                  that.msg = '系统错误，请稍后重试';
                }
                that.$dialog.toast({ mes: that.msg });
            })
          // }else{
          //   that.$dialog.toast({ mes: '卡号格式错误' });
          // }
        
      }else{
          that.$dialog.toast({ mes: '卡号不能为空' });
      }   	    
 		
  	},
  	User: function() {
      let that = this;
      getUser().then(res => {
          console.log(res)
          that.uid = res.data.uid;
      });
    },
    Pad:function(){
      let that = this;
      that.cardsn = this.$route.query.account;
      that.pwd = this.$route.query.psd;
    }

  }  
};
</script>
<style
 scoped>
.bg{
	height: 100%;
	width: 100%;
	position: relative;
}
.bg img{
	display: block;
	width: 100%;
	height: 100%;
}
.forms{
	position: absolute;
	top:50%;
	transform: translateY(-50%);
	width: 80%;
    margin:50px auto;
    left:0;
    right: 0;
}
.forms input{
	display: block;
	background: white;
	margin:30px auto;
	width: 100%;
	height: 40px;
	border-radius: 18px;
	padding-left: 15px;
	font-size: 18px;
}
.ilbox{
  background:rgba(0,0,0,0.5);
  padding:20px;
}
</style>